<template>
    <v-card flat tile outlined style="overflow:hidden">
        <v-card-title>
            <span> 근로자 이력서 </span>
            <v-spacer />
            <application-view v-bind="{ value: value.application }">
                <template #activator="{ attrs, on }">
                    <v-btn small text outlined class="my-n10" v-bind="attrs" v-on="on">
                        <span> 이력서 보기 </span>
                    </v-btn>
                </template>
            </application-view>
        </v-card-title>
        <vertical-form-table
            v-bind="{
                mode: 'view',
                value,
                items,
                style: 'margin-bottom: -1px',
            }"
        ></vertical-form-table>
    </v-card>
</template>

<script>
import { initEmploymentContract } from "@/assets/variables";

import ApplicationView from "@/components/dashboard/company/application/application-view.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

export default {
    components: {
        ApplicationView,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initEmploymentContract },
    },
    computed: {
        items() {
            return [
                {
                    key: "application.resume.personalInformation.name",
                    term: "근로자명",
                },
                {
                    key: "application.resume.personalInformation.phone",
                    term: "연락처",
                    type: "phone",
                },
                {
                    key: "application.resume.personalInformation.email",
                    term: "이메일",
                },
                {
                    key: "application.resume.personalInformation.residence",
                    term: "주소",
                    type: "residence",
                },
                {
                    key: "application.resume.education",
                    term: "학력",
                    type: "education",
                },
            ].map((item) => ({
                ...item,
                headerProps: { style: "width: 100px" },
            }));
        },
    },
};
</script>

<style></style>
